import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import { format } from 'date-fns';

const styles = () => ({
  root: {
    display: "flex",
    alignItems: "flex-end",
    minWidth: "120px",
    flexDirection: "column",
    marginLeft: "40px",
  },

  text1: {
    fontSize: "14px",
    color: "#5A5B62",
    fontWeight: "bold",
  },

  text2: {
    fontSize: "12px",
    color: "#5A5B62",
  },
});

class TimeStamp extends React.Component {
  render() {
    const { classes, status } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.text1}>
          {format(new Date(status.created_at), 'yyyy/MM/dd')}
        </div>
        <div className={classes.text2}>
          {format(new Date(status.created_at), 'HH:mm')}
        </div>
      </div>
    );
  }
}

TimeStamp.propTypes = {
  classes: PropTypes.object.isRequired,
  status: PropTypes.object.isRequired,
};

export default withStyles(styles)(TimeStamp);



// WEBPACK FOOTER //
// ./src/components/Timeline/parts/TimeStamp.jsx